"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _url = require("../../../core/utils/url");
var _elementLocator = require("../../../core/utils/elementLocator");
require("./Anchor.scss");
var _excluded = ["children", "to", "as", "className", "elementLocator", "handleLinkClick", "forceClick", "target"];
var Anchor = function Anchor(_ref) {
  var children = _ref.children,
    to = _ref.to,
    as = _ref.as,
    className = _ref.className,
    elementLocator = _ref.elementLocator,
    handleLinkClick = _ref.handleLinkClick,
    forceClick = _ref.forceClick,
    target = _ref.target,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return _react.default.createElement("a", (0, _extends2.default)({
    href: (0, _url.buildUrl)(to),
    className: className,
    onClick: handleLinkClick,
    target: target,
    "data-locator": elementLocator || "link-" + (0, _elementLocator.getLabelFromChildren)(children)
  }, others, {
    rel: target === '_blank' ? 'noopener noreferrer' : ''
  }), children);
};
Anchor.defaultProps = {
  to: '',
  as: '',
  forceClick: false,
  className: '',
  elementLocator: '',
  target: '_self',
  handleLinkClick: function handleLinkClick() {
    /* default handleLinkClick handler */
  },
  children: _react.default.createElement("div", null)
};
var _default = Anchor;
exports.default = _default;
module.exports = exports["default"];